import React, { Component } from 'react'

class SvgFile extends Component {
  render() {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="8"
        height="14"
        viewBox="0 0 8 14"
      >
        <path
          fill="none"
          fillRule="evenodd"
          stroke="#FF8B0C"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M1 13l6-6-6-6"
        />
      </svg>
    )
  }
}

export default SvgFile



// WEBPACK FOOTER //
// ./src/components/Icons/BookAnotherArrow/SvgFile.js